import React from 'react'
import { Card, CardActionArea, CardContent, CardMedia, Typography, CardHeader, Grid } from '@material-ui/core'
import { Rating } from '@material-ui/lab'
import useStyles from './styles'

const CardMovies = ({ title, year, media, genre, rating, duration, onClick }) => {
  const classes = useStyles()
  const genreProps = genre.split(',')
  const newGenreProps = genreProps.length > 3 ? genreProps.slice(0, 3).join(',') + '...' : genreProps.join(',')

  return (
    <Card className={classes.root} elevation={0}>
      <CardActionArea onClick={onClick} disableRipple>
        <CardHeader
          title={title?.length > 18 ? `${title.slice(0, 18)}...` : title}
          subheader={year}
        />
        <CardMedia
          component="img"
          alt={title}
          height="345"
          image={media}
        />
        <CardContent>
          <Grid container>
            <Grid container item alignItems="center" className={classes.pushDown}>
              <Typography variant="subtitle2" color="textSecondary" className={classes.pushRight}>Genre:</Typography>
              <Typography variant="subtitle2" color="textPrimary">{newGenreProps}</Typography>
            </Grid>
            <Grid container item alignItems="center" className={classes.pushDown}>
              <Typography variant="subtitle2" color="textSecondary" className={classes.pushRight}>Rating:</Typography>
              <Rating value={rating} max={1} size="small" readOnly className={classes.pushRight} />
              <Typography variant="caption">{rating}/10</Typography>
            </Grid>
            <Grid item className={classes.durationContainer}>
              <Typography variant="caption" className={classes.duration}>{duration} mins</Typography>
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default CardMovies
